// @ts-nocheck

module.exports = { VERSION: "6796" };
